import React, { useState, useEffect } from 'react';
import { Alert, Badge, Col, Row } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import generalEntityInfoService from '../../../services/Internal/generalEntityInfo.service';

function FormEntityInformation(props) {
    const [entityInformation, setEntityInformation] = useState({
        formType: "",
        currentSection: "",
        isIndividual: "",
        entityId: 0,
        entityName: "",
        licenseNumber: "",
        lolaNum: "",
        applicationDate: ""

    })
    const [warningCount, setWarningCount] = useState(0);
    const dispatch = useDispatch();
    const updateRecentContacts = () => {
        var token = parseInt(localStorage.getItem('updateRecentContacts')) ? parseInt(localStorage.getItem('updateRecentContacts')) : 0;
        localStorage.setItem('updateRecentContacts', token + 1)
        dispatch({ type: "PERSIST_CURRENT_RECENT_CONTACTS", payload: parseInt(localStorage.getItem('updateRecentContacts')) });
    }
    useEffect(() => {
        setEntityInformation({
            ...props
        })
    }, [props])

    useEffect(() => {
        if (entityInformation.entityId)
            generalEntityInfoService.getWarningsCount(entityInformation.entityId).then((count) => {
                setWarningCount(count.data)
            })
    }, [entityInformation.entityId])

    return (
        <>
            <strong>{entityInformation.currentSection ? (`${entityInformation.formType}`) : ""}</strong>
            <h4>{entityInformation.currentSection ? (`${entityInformation.currentSection}`) : (`${entityInformation.formType}`)} - <a href={entityInformation.isIndividual ? `internal/indCredential?entityId=${entityInformation.entityId}` : `internal/firmCredential?entityId=${entityInformation.entityId}`} target="_blank" onClick={() => updateRecentContacts()}>{entityInformation.entityName}</a>
                {entityInformation.licenseNumber ? `- ${entityInformation.licenseNumber}` : ""}</h4>
            <div className="mb-1">LOLA #{entityInformation.lolaNum}</div>
            <div className="mb-1">Application Date: {entityInformation.applicationDate ? new Date(entityInformation.applicationDate).toLocaleDateString() : ""}</div>
            <Row>
                <Col sm={6}>
                    <Alert style={{ opacity: 1 }} show={warningCount} variant="danger" dismissible={false}>
                        <h5>
                            <FaExclamationTriangle color="#dc3545" size="20" />  Active warning{warningCount > 1 ? 's' : ''}  <Badge variant="danger">{warningCount}</Badge >
                        </h5>
                    </Alert>
                </Col>
            </Row>
        </>
    )
}
export default FormEntityInformation;

